
import React, { useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip';
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import TenantManager from "../../managers/TenantManager";
import {
    DKLabel,
    Toggle,
    DKIcon,
    DKButton,
    INPUT_VIEW_DIRECTION,
    DKRadioButton,
    DKInput,
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE,
    showAlert
} from "deskera-ui-library";
import { DEFAULT_INTEGRATION_ACCOUNTS, INPUT_TYPE } from '../../constants/Constant';
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import { useHistory } from "react-router";
import INComplianceService from '../../services/compliance/INComplianceService';
import SyncJEPopUp from './SyncJEPopUp';
import RevertJEPopup from './RevertJEPopup';
import BooksIntegrationService from '../../services/BooksIntegrationService';
import logo from '../../assets/images/logo.svg'
import deskeraBook from '../../assets/images/Deskera_Books.svg'
import { removeDelayedLoader, showDelayedLoader } from '../../utility/Utility';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

function IntegrationSettings(props) {
    const history = useHistory();

    useEffect(() => {
        RouteManager.setPresenter({ props: props });
        getBooksIntegrationMappingDetails();
    }, []);

    const getBooksIntegrationMappingDetails = () => {
        const timeout = showDelayedLoader();
        INComplianceService.getBooksIntegrationMappingDetails()
            .then((response) => {
                if (response && response['active']) {
                    setIntegrationSettingsData(response);
                    INComplianceService.getExpenseAndLiabilityAccountGroups().then(
                        (response) => {
                            removeDelayedLoader(timeout);
                            if (response && response['content'].length > 0) {
                                setExpenseAndLibilityAccounts(response['content']);
                            }
                        });
                } else {
                    removeDelayedLoader(timeout);
                }
            });
    }

    const setIntegrationSettingsData = (response) => {
        setIntegrationData(response)
        setIntegrationEnabled(response['active']);
        setFlag(response['active'])
        setWhenJEPosted(response['whenJEPosted'] ? response['whenJEPosted'] : "payDate");

        response['mapping'].forEach(element => {
            if (element['payType'] === 'Earnings') {
                setEarnings(element['components'])
                setEarningData({
                    expenseAccount:element['expenseAccount'],
                    liabilityAccount:element['liabilityAccount'],
                    payType:element['payType']
                })
            } else if (element['payType'] === 'Employee Deductions') {
                setEmployeeDeductions(element['components'])
                setEmployeeDeductionsData({
                    expenseAccount:element['expenseAccount'],
                    liabilityAccount:element['liabilityAccount'],
                    payType:element['payType']
                })
            } else if (element['payType'] === 'Employer Contributions') {
                setEmployerContributions(element['components'])
                setEmployeeContributionsData({
                    expenseAccount:element['expenseAccount'],
                    liabilityAccount:element['liabilityAccount'],
                    payType:element['payType']
                })
            }
        });
    }
    const setExpenseAndLibilityAccounts = (content) => {
        setExpenseAccounts(content.filter((x) => x.accountGroup === 'Expenses'));
        setLiabilityAccounts(content.filter((x) => x.accountGroup === 'Current Liabilities'));
    }
    const [integrationEnabled, setIntegrationEnabled] = useState(false);
    const [whenJEPosted, setWhenJEPosted] = useState("payDate");
    const [_flag, setFlag] = useState(false);
    const [earnings, setEarnings] = useState([]);
    const [employeeDeductions, setEmployeeDeductions] = useState([]);
    const [employerContributions, setEmployerContributions] = useState([]);
    const [integrationData, setIntegrationData] = useState({})
    const [expenseAccounts, setExpenseAccounts] = useState([]);
    const [liabilityAccounts, setLiabilityAccounts] = useState([]);
    const [showSyncPopup, setShowSyncPopup] = useState(false);
    const [showRevertPopup, setShowRevertPopup] = useState(false);
    const [earningData, setEarningData] = useState({})
    const [employeeDeductionsData, setEmployeeDeductionsData] = useState({});
    const [employeeContributionsData, setEmployeeContributionsData] = useState({});
    const [masterDataRefresh, setMasterDataRefresh] = useState(false);

    const jePostOptions = [
        { name: "Pay Period End Date", value: "payPeriodEndDate", msg: "The date at which pay period ends" },
        { name: "Pay Date", value: "payDate", msg: "The date at which employees get paid from a specific payrun" }
    ];

    const getDefaultFieldConfig = (type, name, value, validation, options, readOnly, disabled, tooltip) => {
        return {
            type: type,
            name: name,
            value: value,
            validation: validation,
            invalid: false,
            errorMsg: null,
            options: options,
            readOnly: !!readOnly,
            disabled: !!disabled,
            tooltip: tooltip
        }
    }
    const initialJEPostState = {
        newJEPostCriteria: getDefaultFieldConfig("radio", "JEPostCriteria", false, [[]], jePostOptions)
    };
    const [newJEPostCriteria, setnewJEPostCriteria] = useState(initialJEPostState);

    const updateState = (section, setState, state, index, property, value) => {
        setState((prevState) => {
            const newConfig = {
                ...state[property],
                value: value,
                ...hasError(state[property].name, value, state[property].validation, state[property].type)
            };

            let newState;
            if (index === -1) {
                newState = { ...state, [property]: newConfig }
            } else {
                newState = [...prevState];
                newState[index] = { ...state, [property]: newConfig };
            }
            return newState;
        });
    }
    const hasError = (fieldName, value, validation, type) => {
        let error = {
            invalid: false,
            errorMsg: null
        };
        switch (type) {
            case INPUT_TYPE.SELECT:
                if (value && value.length === 0) {
                    value = null;
                }
                break;
        }
        return error;
    }
    const toggleBooksIntegrationSettings = (integrationEnabled) => {
        const payload = {
            active: integrationEnabled
        }

        const timeout = showDelayedLoader();
        INComplianceService.enableBooksIntegration(payload).then(
            (response) => {
                removeDelayedLoader(timeout);
                if (response) {
                    setFlag(_flag => integrationEnabled);
                    showToast(`Integration with Books is now  ${integrationEnabled ? 'Enabled' : 'Disabled'}.`, TOAST_TYPE.SUCCESS);
                    getBooksIntegrationMappingDetails();
                }
            }, (error) => {
                removeDelayedLoader(timeout);
            }
        );
    }
    const getField = (section, state, index, property) => {
        let setState;
        switch (section) {
            case "JEPostCriteria":
                setState = setnewJEPostCriteria;
                break;
        }
        switch (state[property].type) {
            case "radio":
                return (
                    <div className="row p-v-m p-h-m">
                        {state[property].options.map((o) => {
                            return (
                                <div key={o.value} className="row" style={{ width: "auto" }}>
                                    <DKRadioButton
                                        isSelected={o.value === whenJEPosted}
                                        color="bg-app"
                                        onClick={() =>
                                            setWhenJEPosted(o.value)
                                        }
                                    />
                                    <DKLabel className="ml-s" text={o.name} />
                                    <span data-tip={o.msg} className="mr-m ml-s">
                                        <DKIcon style={{ height: 20 }}
                                            src={ic_info_warning}
                                        />
                                    </span>
                                    <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                                </div>
                            )
                        })}
                    </div>
                )
        }
    }

    const enableDisableIntegration = () => {
        setIntegrationEnabled(integrationEnabled => !integrationEnabled);
        toggleBooksIntegrationSettings(!integrationEnabled, true);

    }

    const SyncJE = () => {
        setShowSyncPopup(true)
    }
    const onClose = () => {
        setShowSyncPopup(false)
        setShowRevertPopup(false)
    }
    const revertJE = () => {
        setShowRevertPopup(true)
    }

    const getIntegrationSettingsHeader = () => {
        return <div className="d-flex justify-content-between">
            <DKLabel
                text="Integration Settings"
                className="fs-r text-align-left fw-m fs-l"
            />
            <div className="d-flex">
                {integrationEnabled && PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) && _flag && <DKButton
                    title="Revert"
                    className="border-radius-m bg-gray1 border-m mr-s"
                    onClick={() => {
                        revertJE();
                    }}
                />}
                {integrationEnabled && PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) &&_flag && <DKButton
                    title="Sync"
                    className="border-radius-m bg-gray1 border-m mr-s"
                    onClick={() => {
                        SyncJE()
                    }}
                />}
                <DKButton
                    title="Cancel"
                    className="border-radius-m bg-gray1 border-m mr-s"
                    onClick={() => {
                        RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                    }}
                />
                {integrationEnabled && PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) && _flag && <DKButton
                    title="Save"
                    className="bg-app text-white"
                    onClick={() => {
                        showAlert(
                            "Confirm",
                            "Please ensure that expense/liability account mappings are correct before proceeding.  ",
                            saveOnConfirm()
                          );
                    }}
                />
                }
            </div>
        </div>
    }
    const saveOnConfirm = (data) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        },
        {
            title: "Save",
            className: "bg-app text-white ml-r",
            onClick: () => saveData(),
        },
    ];

    const saveData = () => {
        showLoader("Saving... Please wait");
        let mapping = []
        mapping.push({
            expenseAccount: earningData.expenseAccount,
            liabilityAccount: earningData.liabilityAccount,
            payType: earningData.payType,
            components:earnings
        })
        mapping.push({
            expenseAccount: employeeDeductionsData.expenseAccount,
            liabilityAccount: employeeDeductionsData.liabilityAccount,
            payType: employeeDeductionsData.payType,
            components:employeeDeductions
        })
        mapping.push({
            expenseAccount: employeeContributionsData.expenseAccount,
            liabilityAccount: employeeContributionsData.liabilityAccount,
            payType: employeeContributionsData.payType,
            components:employerContributions
        })
        const { tenant } = TenantManager.getPeopleTenantData();
        let data = {
            active: integrationEnabled,
            countryCode: tenant && tenant.countryCode ? tenant.countryCode : "",
            erpTenantId: integrationData.erpTenantId,
            id: integrationData.id,
            tenantId: integrationData.tenantId,
            whenJEPosted: whenJEPosted,
            mapping:mapping
        }

        BooksIntegrationService.integrationSave(data).then(response=>{
            removeLoader();
            showToast('Integration Settings saved successfully',TOAST_TYPE.SUCCESS)
        },error=>{
            removeLoader();
            console.log(error)
        })
    }
    const getIntegrationWithBooksSection = () => {
        return (<>
            <div className="row p-v-m p-h-m mt-m bg-white border-radius-s shadow-s column">
            <div className="">
                <DKIcon src={logo}/>
                <DKIcon style={{
                    marginLeft:'-27px'
                }} src={deskeraBook}/>
            </div>
                <div className="row">

                    <Toggle className="mr-s border-n" isOn={integrationEnabled} onChange={() => enableDisableIntegration()} />
                    <span className="mb-xs">Integration with Deskera Books</span>
                    <div style={{marginLeft:'auto'}}>
                    {integrationEnabled && <>
                    {_flag && <div className="bg-chip-green text-green border-green p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s">Enabled</div>}
                    </>}
                    {(!(integrationData && _flag)) && <div className="bg-white text-gray border-m p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s">Disabled</div>}
                    </div>
                </div>
            </div>
        </>)
    }

    const getMappingsTableHeader = (x) => {
        return (
            <>
                <tr className="p-v-s">
                    <td className="p-v-s data-grid-bottom-border" style={{ width: "20%" }}>
                        <div className="d-flex">
                            <span className="p-s fw-r fw-m">Pay Type</span>
                        </div>
                    </td>
                    <td className="p-v-s p-h-l data-grid-bottom-border" style={{ width: "40%" }}>
                        <div className="d-flex">
                            <span className="p-s fw-r fw-m">Expense Account</span>
                        </div>
                    </td>
                    <td className="p-v-s p-h-l data-grid-bottom-border" style={{ width: "40%" }}>
                        <div className="d-flex">
                            <span className="p-s fw-r fw-m">Liability Account</span>
                        </div>
                    </td>
                </tr>
            </>
        )
    }

    const getExpenseAccountByKey = (props) => {
        let val = expenseAccounts.filter((x) => x.accountCode === props['expenseAccount'])
        return val[0] ? val[0] : getDefaultExpenseAccount();
    }
    const getDefaultExpenseAccount = () => {
        return {
            'accountCode': DEFAULT_INTEGRATION_ACCOUNTS.EXPENSE_DEFAULT_ACCOUNT,
            "name": "Wage & Salary Expenses",
        }
    }
    const getDefaultLiabilityAccount = () => {
        return {
            'accountCode': DEFAULT_INTEGRATION_ACCOUNTS.LIABILITY_DEFAULT_ACCOUNT,
            "name": "Salary Payable",
        }
    }
    const getLiabilityAccountByKey = (props) => {
        let val = liabilityAccounts.filter((x) => x.accountCode === props['liabilityAccount'])
        return val[0] ? val[0] : getDefaultLiabilityAccount();
    }
    const onSelectField = (obj,value,index,props,section) => {
        switch(section) {
            case 'earnings':
                if(obj == 'expense') {
                    props[index]['expenseAccount'] = value['accountCode']
                } else if(obj == 'liability') {
                    props[index]['liabilityAccount'] = value['accountCode']
                }

                setEarnings(props)
                break ;
            case 'employeeDeductions':
            if(obj == 'expense') {
                props[index]['expenseAccount'] = value['accountCode']
            } else if(obj == 'liability') {
                props[index]['liabilityAccount'] = value['accountCode']
            }

            setEmployeeDeductions(props)
            break ;
            case 'employerContributions':
                if(obj == 'expense') {
                    props[index]['expenseAccount'] = value['accountCode']
                } else if(obj == 'liability') {
                    props[index]['liabilityAccount'] = value['accountCode']
                }

                setEmployerContributions(props);
                break;
        }
    }
    const onSelectFieldForAll = (obj, value, propsData, section) => {
        switch (section) {
            case 'earnings':
                propsData.forEach((ele, ind) => {
                    if (obj == 'expense') {
                        ele['expenseAccount'] = value['accountCode']
                    } else if (obj == 'liability') {
                        ele['liabilityAccount'] = value['accountCode']
                    }
                })
                setEarnings(propsData)
                break;
            case 'employeeDeductions':
                propsData.forEach((ele, ind) => {
                    if (obj == 'expense') {
                        ele['expenseAccount'] = value['accountCode']
                    } else if (obj == 'liability') {
                        ele['liabilityAccount'] = value['accountCode']
                    }
                })
                setEmployeeDeductions(propsData)
                break;
            case 'employerContributions':
                propsData.forEach((ele, ind) => {
                    if (obj == 'expense') {
                        ele['expenseAccount'] = value['accountCode']
                    } else if (obj == 'liability') {
                        ele['liabilityAccount'] = value['accountCode']
                    }
                })
                setEmployerContributions(propsData);
                break;
        }
    }
    const getMappingsTable = (props,section) => {
        return props.map((obj, index) => {
            return (
                <>
                    <tr className="">
                        <td className="p-v-s">
                            <div className="d-flex">
                                <span className="p-s fw-r">{obj.name}</span>
                            </div>
                        </td>
                        <td className="p-v-s">
                            <div className="d-flex pl-xl">
                                <DKInput
                                    className=""
                                    value={getExpenseAccountByKey(obj)}
                                    formatter={(obj) => {
                                        return obj.name;
                                    }}
                                    type={INPUT_TYPE.DROPDOWN}
                                    showError={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={false}
                                    required={true}
                                    canValidate={false}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch: expenseAccounts?.length > 6,
                                        searchableKey: "name",
                                        data: expenseAccounts,
                                        renderer: (index, obj) => {
                                            return (
                                                <DKLabel
                                                    text={`${obj.name}`}
                                                />
                                            );
                                        },
                                        onSelect: (ind, value) => {
                                            onSelectField('expense',value,index,props,section)
                                        },
                                    }}
                                    onChange={value => {
                                    }
                                    }
                                />
                            </div>
                        </td>
                        <td className="p-v-s">
                            <div className="d-flex pl-xl">
                                <DKInput
                                    className=""
                                    formatter={(obj) => {
                                        return obj.name;
                                    }}
                                    value={getLiabilityAccountByKey(obj)}
                                    type={INPUT_TYPE.DROPDOWN}
                                    showError={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={false}
                                    required={true}
                                    canValidate={false}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch: liabilityAccounts?.length > 6,
                                        searchableKey: "name",
                                        data: liabilityAccounts,
                                        renderer: (index, obj) => {
                                            return (
                                                <DKLabel
                                                    text={`${obj.name}`}
                                                />
                                            );
                                        },
                                        onSelect: (ind, value) => {
                                            onSelectField('liability',value,index,props,section)
                                        },
                                    }}
                                    onChange={value => {
                                    }
                                    }
                                />
                            </div>
                        </td>
                    </tr>
                </>
            );
        });
    };

    const getMappingSection = () => {
        return (
            <><div className="bg-white border-radius-s shadow-s">
                <div className="p-v-s p-h-l" >
                    {<table class="width-80">
                        {getMappingsTableHeader()}
                        {getCommonElement(earningData)}
                        {getMappingsTable(earnings,'earnings')}
                    </table>}
                </div>
            </div> <div className="bg-white border-radius-s shadow-s mt-m">
                    <div className="p-v-s p-h-l" >
                        {<table class="width-80">
                            {getMappingsTableHeader()}
                            {getCommonElement(employeeDeductionsData)}
                            {getMappingsTable(employeeDeductions,'employeeDeductions')}
                        </table>}
                    </div>
                </div> <div className="bg-white border-radius-s shadow-s mt-m">
                    <div className="p-v-s p-h-l" >
                        {<table class="width-80">
                            {getMappingsTableHeader()}
                            {getCommonElement(employeeContributionsData)}
                            {getMappingsTable(employerContributions,'employerContributions')}
                        </table>}
                    </div>
                </div>
            </>
        );
    }
    const onSelectedData = (value,obj,section) => {
        switch (obj['payType']) {
            case 'Earnings':
                if(section == 'expense'){
                    obj['expenseAccount'] = value['accountCode']
                    onSelectFieldForAll('expense',value,earnings,'earnings');
                } else if (section == 'liability'){
                    obj['liabilityAccount'] = value['accountCode']
                    onSelectFieldForAll('liability',value,earnings,'earnings');
                }
                setEarningData(obj)
                break;
            case 'Employee Deductions':
                if(section == 'expense'){
                    obj['expenseAccount'] = value['accountCode']
                    onSelectFieldForAll('expense',value,employeeDeductions,'employeeDeductions');
                } else if (section == 'liability'){
                    obj['liabilityAccount'] = value['accountCode']
                    onSelectFieldForAll('liability',value,employeeDeductions,'employeeDeductions');
                }
                setEmployeeDeductionsData(obj)
                break;
            case 'Employer Contributions':
                if(section == 'expense'){
                    obj['expenseAccount'] = value['accountCode']
                    onSelectFieldForAll('expense',value,employerContributions,'employerContributions');
                } else if (section == 'liability'){
                    obj['liabilityAccount'] = value['accountCode']
                    onSelectFieldForAll('liability',value,employerContributions,'employerContributions');
                }
                setEmployeeContributionsData(obj)
                break;
        }
        setMasterDataRefresh(masterDataRefresh=>!masterDataRefresh)
    }
    const getCommonElement = (obj) =>{
        let name = obj['payType']
        return (
            <>
                <tr className="">
                    <td className="p-v-s data-grid-bottom-border">
                        <div className="d-flex">
                            <span className="p-s fw-m">{name}</span>
                        </div>
                    </td>
                    <td className="p-v-s data-grid-bottom-border">
                        <div className="d-flex pl-xl">
                            <DKInput
                                className=""
                                value={getExpenseAccountByKey(obj)}
                                formatter={(obj) => {
                                    return obj.name;
                                }}
                                type={INPUT_TYPE.DROPDOWN}
                                showError={true}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={false}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: expenseAccounts?.length > 6,
                                    searchableKey: "name",
                                    data: expenseAccounts,
                                    renderer: (index, obj) => {
                                        return (
                                            <DKLabel
                                                text={`${obj.name}`}
                                            />
                                        );
                                    },
                                    onSelect: (ind, value) => {
                                        onSelectedData(value,obj,'expense')
                                    },
                                }}
                                onChange={value => {
                                }
                                }
                            />
                        </div>
                    </td>
                    <td className="p-v-s data-grid-bottom-border">
                        <div className="d-flex pl-xl">
                            <DKInput
                                className=""
                                formatter={(obj) => {
                                    return obj.name;
                                }}
                                value={getLiabilityAccountByKey(obj)}
                                type={INPUT_TYPE.DROPDOWN}
                                showError={true}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={false}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: liabilityAccounts?.length > 6,
                                    searchableKey: "name",
                                    data: liabilityAccounts,
                                    renderer: (index, obj) => {
                                        return (
                                            <DKLabel
                                                text={`${obj.name}`}
                                            />
                                        );
                                    },
                                    onSelect: (ind, value) => {
                                        onSelectedData(value,obj,'liability')
                                    },
                                }}
                                onChange={value => {
                                }

                                }
                            />
                        </div>
                    </td>
                </tr>
            </>
        );
    }

    const getIntegrationWithBooksMappingForm = () => {
        return (
            <div className="pb-xl">
                <div className="p-v-m p-h-m">
                    <span>When should the Journal Entry be posted?</span>
                    {getField("JEPostCriteria", newJEPostCriteria, -1, "newJEPostCriteria")}
                </div>
                <div className="row p-v-m p-h-m bg-deskera-secondary">
                    <DKIcon className="mr-s" src={ic_info_warning} />
                    The journal entry posted will be grouped together for all the individuals in the payrun and will be considered as a single transaction.
                </div>
                {getMappingSection()}
            </div>
        );
    }

    const getIntegrationSettingsForm = () => {
        return (
            <div className="pb-xl" style={{
                pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
              }}>
                {getIntegrationWithBooksSection()}
                {integrationEnabled && _flag && getIntegrationWithBooksMappingForm()}
            </div>
        );

    }

    return (
        <div className="parent-width">
            {getIntegrationSettingsHeader()}
            {getIntegrationSettingsForm()}
            {showSyncPopup && (
                <div className="transparent-background" style={{
                    pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                    opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                  }}>
                    <SyncJEPopUp
                    {...props}
                        onClose={() => onClose()}
                    />
                </div>
            )}
            {showRevertPopup && (
                <div className="transparent-background" style={{
                    pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                    opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                  }}>
                    <RevertJEPopup
                    {...props}
                        onClose={() => onClose()}
                    />
                </div>
            )}
        </div>
    );
}

export default IntegrationSettings